import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { t } from 'i18next';
import { RadixTabs } from '@/components/radix';
import DoctorsNotificationsBell from './DoctorsNotificationsBell';
import '../../tailwind.css';

export default function DoctorsLayout() {
    const navigate = useNavigate();
    const location = useLocation();
    const currentTab =
        location.pathname === '/doctors/instructions'
            ? 'instructions'
            : location.pathname === '/doctors/messages'
              ? 'messages'
              : location.pathname === '/doctors/logs'
                ? 'logs'
                : 'doctors';

    return (
        <section className="h-screen flex flex-col bg-background-paper">
            <div className="sticky top-0 z-50 bg-background-paper shadow-md">
                <div className="flex items-center justify-between w-full">
                    <RadixTabs
                        items={[
                            { value: 'doctors', label: t('Setting.Doctors') },
                            { value: 'instructions', label: t('Doctors.TabInstructions') },
                            { value: 'messages', label: t('Doctors.TabMessages') },
                            { value: 'logs', label: t('Customer.Logs') },
                        ]}
                        className="flex-1 overflow-x-auto scrollbar-hidden"
                        listClassName="w-full gap-4 px-8"
                        triggerClassName="text-base font-semibold whitespace-nowrap"
                        value={currentTab}
                        onValueChange={(value) => {
                            if (value === 'instructions') navigate('/doctors/instructions');
                            else if (value === 'messages') navigate('/doctors/messages');
                            else if (value === 'logs') navigate('/doctors/logs');
                            else navigate('/doctors');
                        }}
                    />
                    <div className="pr-4 flex-shrink-0 flex items-center">
                        <DoctorsNotificationsBell />
                    </div>
                </div>
            </div>

            <section className="flex-1 overflow-y-auto mx-auto scrollbar-hidden w-full max-w-[1400px] p-3 md:p-6">
                <Outlet />
            </section>
        </section>
    );
}
